import { TasksTabs } from 'pages/TaskTemplates/DragComponents/Tasks.styled'
import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DropDownTab = styled(TasksTabs)`
  position: relative;
  @media (max-width: 1300px) {
    margin-bottom: 1rem;
  }
`

interface IDropDownOptionTabs {
  showDropDown: boolean
}

export const DropDownOptionTabs = styled.div<IDropDownOptionTabs>`
  position: absolute;
  top: 110%;
  left: 50%;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  padding: 10px;
  transition: 0.2s ease;
  transform-origin: top;

  background: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  box-shadow: ${tokens.shadow.card};
  ${(props) =>
    props.showDropDown
      ? 'opacity:1; { transform: scaleY(1)  translateX(-50%)}'
      : 'opacity:0; { transform: scaleY(0)  translateX(-50%)}'}

  @media (max-width: 1300px) {
    width: 100%;
  }
`
